   <template>
<div>
       <Header/>

<!--End mainmenu area--> 

<!--Start breadcrumb area-->

<section class="breadcrumb-area" v-bind:style="{backgroundImage: 'url('+this.pagebanner+ ')' }">
	<div class="container text-center">
		<h1 v-if="pagedata">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</h1>
		<span class="border"></span>
	</div>
</section>
<!--End breadcrumb area-->
         
<!--Start breadcrumb bottom area--> 
<section class="breadcrumb-bottom-area">
    <div class="container">
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <a href="#"></a>    
        </div>
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <ul>
               <li><a :href="$i18n.locale == 'en' ? '../../../../en/': '../../../../ar/'">{{ $i18n.locale == 'en' ? 'Home':'الرئيسية' }}</a></li>
               <li>></li>
                <li><a href="#">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</a></li>

                
            </ul>    
        </div>        
    </div>    
</section>         
<!--End breadcrumb bottom area-->
         
<!--Start faq content area-->


  <section style="margin-bottom:5px!important" class="account-area" v-for="accounts in accountbranches" v-bind:key="accounts.id">
<div class="container">
<div class="row">
<div class="col-lg-4 col-md-5 col-sm-12 col-xs-12">
<div class="form login-form">
<div class="row">
</div>
<div class="col-md-12">
<div class="remember-me pull-left">
<div class="checkbox">
</div>
</div>
<div class="forgot-password pull-right">
</div>
</div>
<div class="col-md-12">
</div>
</div>
</div>
<div class="col-lg-8 col-md-7 col-sm-12 col-xs-12">
<div class="form register">
<div class="sec-title two" >
<h1 v-html="$i18n.locale == 'en' ? accounts.nameen:accounts.namear">{{ $i18n.locale == 'en' ? accounts.nameen:accounts.namear }}</h1>
</div>
<form action="#">
<div class="row">
<div class="col-md-6">
<div class="field-input">
<div class="icon-holder">
</div>
</div>
</div>
<div class="col-md-6">
<div class="field-input">
<div class="icon-holder">
</div>
</div>
</div>
<div class="col-md-6">
<div class="field-input">
<div class="icon-holder">
</div>
</div>
</div>
<div class="col-md-6">
<div class="icon-holder">
<span class=""></span>
</div>
</div>
</div>
<ul class="brochures-lists">
<li>
<a href="#">
</a><a  :href="$i18n.locale == 'en' ? '../../../../en/agreement': '../../../../ar/agreement'">{{ $i18n.locale == 'en' ? 'To view the customer agreement':'لمشاهدة إتفاقية العميل' }}</a>
<div class="col-md-12">
<div class="term-condition">
<div class="checkbox">
<span>{{ $i18n.locale == 'en' ? 'I accept the customer statement':'أوافق على إقرار العميل و يرجى فتح و متابعة حسابي من قبل فرع شرق - برج جرافيتي' }}</span>
<label style="min-height: 15px;!important;">
<input v-model="checked[accounts.id]" style="float:right!important;" type="checkbox"  name="condition" >
</label>
</div>
</div>
</div>
<div class="col-md-6">
<a :href="accounts.link1" :disabled="!checked[accounts.id]"  target="_blank"><button :disabled="!checked[accounts.id]" class="cre-acc" type="button"> {{ $i18n.locale == 'en' ? 'Open Demo Account':'فتح حساب حقيقي' }}</button></a>
</div> <div class="col-md-6">
<a :href="accounts.link2" :disabled="!checked[accounts.id]" target="_blank"><button :disabled="!checked[accounts.id]" class="cre-acc" type="button">{{ $i18n.locale == 'en' ? 'Open Real Account':'فتح حساب تجريبي' }}</button></a>
</div>
</li>
</ul></form></div>
</div>
</div>
</div>
</section>


<!--End faq content area-->
	<!--Start slogan area-->
<section class="slogan-area">
    <div class="container">
        <div class="title pull-center">
            <h2>{{ $i18n.locale == 'en' ? pagefooteren: pagefooterar  }}</h2>    
        </div>
        <div class="buttons pull-right">
        </div>
    </div>    
</section>
<!--End slogan area-->
<!--Start footer area-->  

   
            <Footer/>
 </div>
    </div>
</template>

<script>
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery-1.11.1.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.bxslider.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.countTo.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.appear.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/owl.carousel.min.js";

import  "https://wafrafrontend.marketequityinc.com/src/assets/js/validate.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.mixitup.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.easing.min.js";
import "http://maps.google.com/maps/api/js?sensor=true";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/fancyapps-fancyBox/source/jquery.fancybox.pack.js";		

import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.tools.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.revolution.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.actions.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.carousel.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.kenburn.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.layeranimation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.migration.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.navigation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.parallax.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.slideanims.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.video.min.js";




import "https://wafrafrontend.marketequityinc.com/src/assets/js/custom.js";
</script>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'Home',
    title: 'Home',
    data() {
                   

        return {
            langs: ['en', 'ar'],
           
            homepageblocks: '',
            homeblock1: null,
            homeblockimage1: null,
            homepageblocksicons: [],
            homepageblocksicons3: [],
            homepageblocks2: '',
            ceomessage: '',
            successstories: '',
            slide1image:'',
            slide2image:'',
            slide3image:'',
            techanalysis:'',
            pagedata:'',
            pagebanner:'',
            crosses:'',
            currencydata:'',
            accountbranches:'',
             checked:[],
             
            

        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
          var pathvalues = (this.$route.path).split("/");
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'ar';
        }
       

        this.loadpagedata('account');
        this.loadaccountbranches();
                this.loaddata();



    },
    mounted() {
        
        this.loadpagedata('account');
        this.loadaccountbranches();
        this.loaddata();

       
    },

    methods: {
  
       loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {

                       
                        this.pagefooteren = res.data.sitesettings[0].pagefooteren;
                        this.pagefooterar = res.data.sitesettings[0].pagefooterar;
                      
                    }
                });
        },
       loadpagedata(pagename) {
            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                          if (res.data.code == 200) {
                        this.pagedata = res.data.pagedata[0];
                        this.pagebanner=this.serverurl+'/public/pagebanners/'+res.data.pagedata[0].pagebanner;
                          }
                        else{

                            this.$router.push({ name: 'NotFound' })
                        }
                    }
                });
            

        },
        loadaccountbranches() {

            this.$axios.get("loadaccountbranches",
            )
                .then(res => {
                    if (res) {

                        this.accountbranches = res.data.accountbranches;

                    }
                });
        },

    }
}
</script>
<style>
#div1::after{
    clear: none!important;
    
}
.carousel {
  background: #2f435700!important;
}
    
</style>
